import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import c2 from '../carousel2.jpg';
import c3 from '../carousel3.jpg';
import c4 from '../carousel4.jpg';
import c5 from '../carousel5.jpg';
import c6 from '../carousel6.jpg';
import c7 from '../carousel7.jpg';
import masif1 from '../masif1.jpg';
import masif2 from '../masif2.jpeg';
import masif3 from '../masif3.jpg';
import zemin1 from '../zemin1.jpg';
import zemin2 from '../zemin2.jpg';
import zemin3 from '../zemin3.jpg';
import duvar1 from '../duvar1.jpg';
import duvar2 from '../duvar2.jpg';
import duvar3 from '../duvar3.jpg';
import ahsap1 from '../ahsap1.jpg';
import ahsap2 from '../ahsap2.jpg';
import ahsap3 from '../ahsap3.jpg';

const services = [
  { icon: '🌲', title: 'Ham Kereste Üretimi', desc: 'Sürdürülebilir ormanlardan tedarik ettiğimiz ahşabı modern teknolojilerle işleyerek en kaliteli ürünleri sunuyoruz.' },
  { icon: '🪵', title: 'Özel Mobilya Tasarımı', desc: 'Yaşam alanlarınıza özel, ergonomik ve estetik mobilyaları ustalarımızla tasarlayıp üretiyoruz.' },
  { icon: '🏠', title: 'İç Mekan Kaplama', desc: 'Duvar, tavan ve zemin kaplamalarında ahşabın sıcaklığını evinize ve ofisinize getiriyoruz.' },
  { icon: '🚪', title: 'Kapı & Pencere', desc: 'Masif ahşap ve ahşap-alüminyum sistemlerle dayanıklı ve şık kapı-pencere çözümleri üretiyoruz.' },
  { icon: '🏗️', title: 'Ahşap Yapı Sistemleri', desc: 'Prefabrik ahşap evlerden ticari yapılara kadar çevre dostu ve sağlam ahşap konstrüksiyonlar kuruyoruz.' },
  { icon: '✨', title: 'Restorasyon & Onarım', desc: 'Tarihi ve değerli ahşap eserlerin orijinal dokusunu koruyarak yenileme ve restorasyon hizmetleri sunuyoruz.' },
];

const features = [
  { title: 'Sürdürülebilir Kaynak', desc: 'FSC sertifikalı ormanlardan tedarik ettiğimiz ahşap ile çevreye duyarlı üretim gerçekleştiriyoruz.' },
  { title: 'El İşçiliği + Teknoloji', desc: 'CNC teknolojisi ve usta el işçiliğini bir arada kullanarak eşsiz kalitede ürünler üretiyoruz.' },
  { title: 'Uluslararası Standartlar', desc: 'ISO 9001 ve CE belgeleriyle Avrupa ve dünya standartlarında üretim yapıyoruz.' },
];

const products = [
  { title: 'Masif Ahşap Mobilya', sub: 'Doğanın dokusunu yaşam alanlarınıza taşıyoruz', images: [masif1, masif2, masif3] },
  { title: 'Deck & Zemin Kaplama', sub: 'Dış mekânlarınızı ahşabın sıcaklığıyla buluşturuyoruz', images: [zemin1, zemin2, zemin3] },
  { title: 'Dekoratif Duvar Kaplama', sub: 'Duvarlarınıza karakter ve derinlik katıyoruz', images: [duvar1, duvar2, duvar3] },
  { title: 'Ahşap Yapı & Pergola', sub: 'Hayalinizdeki yaşam alanlarını inşa ediyoruz', images: [ahsap1, ahsap2, ahsap3] },
];

const carouselSlides = [
  { img: c2, label: '' },
  { img: c3, label: '' },
  { img: c4, label: '' },
  { img: c5, label: '' },
  { img: c6, label: '' },
  { img: c7, label: '' },
];

const reviews = [
  {
    name: 'Ayfer Ayna',
    time: '5 yıl önce',
    text: 'İyi kalitede ürünler çıkartıyorlar. Tavsiye ederim. Teşekkürler Element Global',
    stars: 5,
  },
  {
    name: 'Bahtiyar Altun',
    time: '3 yıl önce',
    text: 'İşini hakkıyla yapan nadir firmalardan. Element global shop sayfasından da sipariş verdik, siparişimizi sorunsuz teslim ettiler. Tavsiye ederim.',
    stars: 5,
  },
  {
    name: 'Ayşenur Yıldızgil',
    time: '2 yıl önce',
    text: 'Çok başarılı bir firma, tam olarak hayal ettiğimiz ürünü bize teslim ettiler. Kesinlikle kaliteli hizmetleri için teşekkür ederiz ✨',
    stars: 5,
  },
];

function AnimatedStat({ target, suffix = '+', label }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let startTime = null;
    const duration = 6000;
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      setCount(Math.floor(eased * target));
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(target);
      }
    };
    const raf = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(raf);
  }, [target]);

  return (
    <div>
      <div className="stat-num">{count.toLocaleString('tr-TR')}{suffix}</div>
      <div className="stat-label">{label}</div>
    </div>
  );
}

function ProductCard({ title, sub, images, current }) {
  return (
    <div className="product-card">
      <div className="product-img" style={{ position: 'relative', overflow: 'hidden' }}>
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt={title}
            style={{
              position: i === 0 ? 'relative' : 'absolute',
              top: 0, left: 0,
              width: '100%', height: '100%',
              objectFit: 'cover',
              opacity: current === i ? 1 : 0,
              transition: 'opacity 0.5s ease',
              display: 'block',
            }}
          />
        ))}
        <div style={{
          position: 'absolute', bottom: '10px', left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex', gap: '6px', zIndex: 2,
        }}>
          {images.map((_, i) => (
            <div key={i} style={{
              width: current === i ? '18px' : '6px',
              height: '6px', borderRadius: '3px',
              background: current === i ? '#fff' : 'rgba(255,255,255,0.5)',
              transition: 'all 0.3s',
            }} />
          ))}
        </div>
      </div>
      <div className="product-info">
        <h4>{title}</h4>
        <p>{sub}</p>
      </div>
    </div>
  );
}

function ProductsGrid() {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % 3);
    }, 5000);
    return () => clearInterval(timer);
  }, [paused, current]);

  return (
    <div
      style={{ position: 'relative' }}
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <button
        onClick={() => setCurrent(prev => (prev - 1 + 3) % 3)}
        style={{
          position: 'absolute', left: '-14px', top: '40%',
          transform: 'translateY(-50%)', zIndex: 10,
          background: 'rgba(59,42,26,0.35)', border: '1px solid rgba(196,154,108,0.3)', color: 'rgba(245,239,230,0.8)',
          width: '32px', height: '32px', borderRadius: '50%',
          cursor: 'pointer', fontSize: '16px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: 'none', transition: 'background 0.3s',
        }}
      >‹</button>

      <div className="products-grid">
        {products.map((p, i) => (
          <ProductCard key={i} title={p.title} sub={p.sub} images={p.images} current={current} />
        ))}
      </div>

      <button
        onClick={() => setCurrent(prev => (prev + 1) % 3)}
        style={{
          position: 'absolute', right: '-14px', top: '40%',
          transform: 'translateY(-50%)', zIndex: 10,
          background: 'rgba(59,42,26,0.35)', border: '1px solid rgba(196,154,108,0.3)', color: 'rgba(245,239,230,0.8)',
          width: '32px', height: '32px', borderRadius: '50%',
          cursor: 'pointer', fontSize: '16px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          boxShadow: 'none', transition: 'background 0.3s',
        }}
      >›</button>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '24px' }}>
        {[0, 1, 2].map(i => (
          <button key={i} onClick={() => setCurrent(i)} style={{
            width: i === current ? '24px' : '8px', height: '8px',
            borderRadius: '4px', border: 'none', cursor: 'pointer',
            background: i === current ? 'var(--wood-dark)' : 'rgba(59,42,26,0.2)',
            transition: 'all 0.3s', padding: 0,
          }} />
        ))}
      </div>
    </div>
  );
}

function AboutCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % carouselSlides.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [current]);

  return (
    <div style={{ position: 'relative', width: '100%', aspectRatio: '3/4', overflow: 'visible' }}>
      {carouselSlides.map((slide, i) => (
        <div
          key={i}
          style={{
            position: 'absolute', inset: 0,
            opacity: current === i ? 1 : 0,
            transition: 'opacity 0.8s ease',
            overflow: 'hidden',
          }}
        >
          <img
            src={slide.img}
            alt={slide.label}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
          <div style={{
            position: 'absolute', bottom: 0, left: 0, right: 0,
            background: 'linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 100%)',
            padding: '48px 28px 28px',
          }}>
            <div style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: '20px', color: '#fff',
              fontWeight: 600, letterSpacing: '0.5px',
            }}>
              {slide.label}
            </div>
          </div>
        </div>
      ))}
      <div style={{
        position: 'absolute', bottom: '16px', right: '16px',
        display: 'flex', gap: '8px', zIndex: 2,
      }}>
        {carouselSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            style={{
              width: i === current ? '24px' : '8px',
              height: '8px', borderRadius: '4px',
              background: i === current ? 'var(--wood-light)' : 'rgba(245,239,230,0.4)',
              border: 'none', cursor: 'pointer',
              transition: 'all 0.3s', padding: 0,
            }}
          />
        ))}
      </div>
      <button
        onClick={() => setCurrent(prev => (prev - 1 + carouselSlides.length) % carouselSlides.length)}
        style={{
          position: 'absolute', left: '-18px', top: '50%', transform: 'translateY(-50%)',
          background: 'rgba(0,0,0,0.3)', border: 'none', color: '#fff',
          width: '36px', height: '36px', borderRadius: '50%',
          cursor: 'pointer', fontSize: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 2,
        }}
      >‹</button>
      <button
        onClick={() => setCurrent(prev => (prev + 1) % carouselSlides.length)}
        style={{
          position: 'absolute', right: '-18px', top: '50%', transform: 'translateY(-50%)',
          background: 'rgba(0,0,0,0.3)', border: 'none', color: '#fff',
          width: '36px', height: '36px', borderRadius: '50%',
          cursor: 'pointer', fontSize: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 2,
        }}
      >›</button>
    </div>
  );
}

function TestimonialCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setCurrent(p => (p + 1) % reviews.length), 5000);
    return () => clearInterval(t);
  }, [current]);

  const r = reviews[current];

  return (
    <section className="testimonial">
      <div className="testimonial-inner">
        <div style={{display:'flex', justifyContent:'center', gap:'4px', marginBottom:'16px'}}>
          {[...Array(r.stars)].map((_, i) => (
            <span key={i} style={{color:'var(--wood-light)', fontSize:'22px'}}>★</span>
          ))}
        </div>
        <div className="quote-mark">"</div>
        <p className="testimonial-text">{r.text}</p>
        <div className="testimonial-author">{r.name}</div>
        <div style={{fontSize:'12px', color:'rgba(196,154,108,0.5)', letterSpacing:'1px', marginTop:'8px', textTransform:'uppercase'}}>
          Google Yorumu · {r.time}
        </div>
        <div style={{display:'flex', gap:'8px', justifyContent:'center', marginTop:'32px'}}>
          {reviews.map((_, i) => (
            <button key={i} onClick={() => setCurrent(i)} style={{
              width: i === current ? '24px' : '8px', height: '8px',
              borderRadius: '4px', border: 'none', cursor: 'pointer',
              background: i === current ? 'var(--wood-light)' : 'rgba(196,154,108,0.3)',
              transition: 'all 0.3s', padding: 0,
            }} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <section className="hero">
        <div className="hero-content">
           <div className="hero-badge">Ahşap'ta 15 Yıllık Ustalık</div>
          <h1>Doğanın<br />Özünden<br /><em>Sanat Eserleri</em></h1>
          <p className="hero-desc">Ahşabın sıcaklığını ve doğallığını yaşam alanlarınıza taşıyor, her projede en ince detaya kadar özen gösteriyoruz.</p>
          <div className="hero-btns">
            <Link to="/urunler" className="btn-primary">Projelerimizi Keşfet</Link>
            <Link to="/iletisim" className="btn-outline">Bize Ulaşın</Link>
          </div>
          <div className="hero-stats">
<AnimatedStat target={15} suffix="+" label="Yıllık Deneyim" />
            <AnimatedStat target={1200} suffix="+" label="Tamamlanan Proje" />
<AnimatedStat target={10} suffix="+" label="Ülkeye İhracat" />          </div>
        </div>
        <div className="hero-img">
          <svg className="wood-rings" viewBox="0 0 500 500" fill="none">
            <circle cx="250" cy="250" r="240" stroke="rgba(196,154,108,0.08)" strokeWidth="1"/>
            <circle cx="250" cy="250" r="210" stroke="rgba(196,154,108,0.1)" strokeWidth="1.5"/>
            <circle cx="250" cy="250" r="180" stroke="rgba(196,154,108,0.12)" strokeWidth="1"/>
            <circle cx="250" cy="250" r="150" stroke="rgba(196,154,108,0.15)" strokeWidth="2"/>
            <circle cx="250" cy="250" r="120" stroke="rgba(196,154,108,0.18)" strokeWidth="1.5"/>
            <circle cx="250" cy="250" r="90"  stroke="rgba(196,154,108,0.22)" strokeWidth="1"/>
            <circle cx="250" cy="250" r="60"  stroke="rgba(196,154,108,0.28)" strokeWidth="2"/>
            <circle cx="250" cy="250" r="30"  stroke="rgba(196,154,108,0.35)" strokeWidth="1.5"/>
            <circle cx="250" cy="250" r="10"  fill="rgba(196,154,108,0.2)"/>
          </svg>
        </div>
      </section>

      <section className="section">
        <div className="section-tag">Ne Yapıyoruz</div>
        <div className="services-header">
          <div className="section-title">Ahşap İşçiliğinde<br />Kapsamlı Çözümler</div>
          <p className="section-sub">Ham malzemeden teslimata kadar her aşamada yanınızdayız.</p>
        </div>
        <div className="services-grid">
          {services.map((s, i) => (
            <div className="service-card" key={i}>
              <div className="service-icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              <Link to="/hizmetler" className="arrow">Daha Fazla →</Link>
            </div>
          ))}
        </div>
      </section>

      <section className="section about-bg">
        <div className="about-inner">
          <AboutCarousel />
          <div>
            <div className="section-tag">Biz Kimiz</div>
            <div className="section-title about-title">Ormandan Evinize,<br />Ustalıkla</div>
            <p className="about-desc">2010'dan bu yana ahşabın sıcaklığını ve doğallığını yaşam alanlarına taşıyan Element Global, Türkiye'nin önde gelen ahşap işleme ve mobilya firmaları arasında yer almaktadır.</p>
            <div className="feature-list">
              {features.map((f, i) => (
                <div className="feature-item" key={i}>
                  <div className="feature-dot" />
                  <div><h4>{f.title}</h4><p>{f.desc}</p></div>
                </div>
              ))}
            </div>
            <div style={{marginTop:'40px'}}>
              <Link to="/hakkimizda" className="btn-dark">Daha Fazla Bilgi →</Link>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="products-header">
          <div>
            <div className="section-tag">Ürün Kategorileri</div>
            <div className="section-title">Koleksiyonlarımız</div>
          </div>
          <Link to="/urunler" className="btn-all">Tümünü Gör →</Link>
        </div>
        <ProductsGrid />
      </section>

      <TestimonialCarousel />
    </>
  );
}